/**
 * @generated SignedSource<<97176881040af6921b58049138500f2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegateProfileImageFragment$data = {
  readonly address: {
    readonly resolvedName: {
      readonly address: string;
      readonly " $fragmentSpreads": FragmentRefs<"ENSAvatarFragment" | "NounResolvedNameFragment">;
    };
  };
  readonly tokensRepresentedVote: {
    readonly amount: {
      readonly " $fragmentSpreads": FragmentRefs<"TokenAmountDisplayFragment">;
    };
  };
  readonly " $fragmentType": "DelegateProfileImageFragment";
};
export type DelegateProfileImageFragment$key = {
  readonly " $data"?: DelegateProfileImageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DelegateProfileImageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DelegateProfileImageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResolvedName",
          "kind": "LinkedField",
          "name": "resolvedName",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NounResolvedNameFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ENSAvatarFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VotingPower",
      "kind": "LinkedField",
      "name": "tokensRepresentedVote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TokenAmount",
          "kind": "LinkedField",
          "name": "amount",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TokenAmountDisplayFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "f8d8c44ceee979a68dce0721309702be";

export default node;
